import { render, staticRenderFns } from "./TotalEventsWidget.vue?vue&type=template&id=e52bebd2&scoped=true&lang=pug"
import script from "./TotalEventsWidget.vue?vue&type=script&lang=js"
export * from "./TotalEventsWidget.vue?vue&type=script&lang=js"
import style0 from "./TotalEventsWidget.vue?vue&type=style&index=0&id=e52bebd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52bebd2",
  null
  
)

export default component.exports